import i18n from "@/language/i18n";
import TIMETRACKING_WIDGETS from "@/configuration/widgets/TIMETRACKING_WIDGETS";
import MONTH_WIDGETS from "@/configuration/widgets/MONTH_WIDGETS";
import SICK_NOTES_WIDGETS from "@/configuration/widgets/SICK_NOTES_WIDGETS";

const WORKING_TIME_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    TIMETRACKING_MODULE_WINDOW_ID: 'timetracking',
    ATTENDANCE_TYPES_MODULE_WINDOW_ID: 'attendancetypes',
    OVERTIME_MODULE_WINDOW_ID: 'overtime',
    OVERTIMETRIMS_MODULE_WINDOW_ID: 'overtimetrims',
    MONTH_CLOSING_OVERVIEW_MODULE_ID: 'monthClosingOverview',
    MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID: 'monthOfEmployees',
    REOPEN_MONTH_MODULE_WINDOW_ID: 'reopenMonth',
    MONTHLY_VERIFICATION_MODULE_ID: 'monthlyVerification',
    SICK_NOTES_MODULE_WINDOW_ID: 'sicknotes',
    CALENDAR_MODULE_WINDOW_ID: 'calendar',
});

export { WORKING_TIME_MODULE_WINDOW_IDENTIFIER };

export default {
    WORKING_TIME_GROUP_WRAPPER: {
        type: 'group',
        id: 'workingTimeManagement',
        label: i18n.t('ModuleRegistry.groups.workingTimeManagement.name'),
        children: [],
        icon: '$wTime',
        sidebarIcon: '$wNavWorkingTimeManagment'
    },
    CHILDREN: {
        TIMETRACKING_MODULE: {
            type: 'module',
            id: 'timetracking',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.TIMETRACKING_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.timeTracking.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/timetracking'
        },
        ATTENDANCE_TYPES_MODULE: {
            type: 'module',
            id: 'attendanceTypes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.ATTENDANCE_TYPES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.attendanceTypes.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/attendanceTypes'
        },
        OVERTIME_MODULE: {
            type: 'module',
            id: 'overtime',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OVERTIME_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.overtime.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/overtime',
            widgets: TIMETRACKING_WIDGETS.OVERTIME_WIDGETS
        },
        OVERTIME_TRIM_MODULE: {
            type: 'module',
            id: 'overtimeTrimOverview',
            windowIdentifierType:
                WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OVERTIMETRIMS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.overtimeTrimOverview.label'),
            navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
            routerLink: '/overtimetrims',
            globalSearch: {
                index: 'overtimetrims'
            },
        },
        MONTH_CLOSING_OVERVIEW_MODULE: {
            type: 'module',
            id: 'monthClosingOverview',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_CLOSING_OVERVIEW_MODULE_WINDOW_ID,
            label: 'Monatsabschluss',
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthClosingOverview',
        },
        MONTH_OF_EMPLOYEES_MODULE: {
            type: 'module',
            id: 'monthOfEmployees',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.overview'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthOfEmployees',
            widgets: MONTH_WIDGETS.MONTH_OF_EMPLOYEES_WIDGETS
        },
        REOPEN_MONTH_MODULE: {
            type: 'module',
            id: 'reopenMonth',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.REOPEN_MONTH_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.reopenMonth'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reopenMonth',
        },
        MONTHLY_VERIFICATION_MODULE: {
            type: 'module',
            id: 'monthlyVerificationView',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_VERIFICATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.verification'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthlyVerification',
        },
        SICK_NOTES_MODULE: {
            type: 'module',
            id: 'sickNotes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.SICK_NOTES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/sickNotes',
            globalSearch: {
                index: 'sicknotes',
                presentation: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.presentation'),
                component: 'SickNoteItem.vue',
                shortcut: '-s'
            },
            widgets: SICK_NOTES_WIDGETS.SICK_NOTES_WIDGETS
        },
        CALENDAR_MODULE: {
            type: 'module',
            id: 'monthCalendar',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.CALENDAR_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.calendar'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/calendar',
        },
    }
}
